<template>
  <div class="footer" :class="{ active: isSidebarCollapsed }">
    <nav class="navbar navbar-default footer-navbar mb-0">
      <div class="container-fluid">
        <app-normal-button title="印刷" class="mr-2" :link="printableLink" target="_blank" />
        <app-normal-button title="コピー" class="mr-2" @click.native="copyToClipboard($event)" />
        <app-normal-squere-icon-button
          title="電子カルテへコピー済み"
          :checked="isCopied"
          @click.native="toggleIsCopied($event)"
        />
        <p v-if="customerDeleted" class="customer-deleted">※ 病院登録解除しているため送信できません</p>
        <app-primary-button
          :title="messageLinkTitle"
          :link="messageLink"
          :disabled="customerDeleted"
          class="ml-auto"
        />
      </div>
    </nav>

    <!-- eslint-disable-next-line vue/no-textarea-mustache -->
    <textarea id="clipboard">{{ clipboard }}</textarea>
  </div>
</template>

<script>
import { action } from '@/utility/event-bus';
import { eventBus } from '@/utility/event-bus';
import toastr from '@v2/atoms/clinic/WideToastr.vue';

export default {
  props: {
    clipboard: {
      type: String,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    messageLink: {
      type: String,
      required: true,
    },
    messageLinkTitle: {
      type: String,
      required: true,
    },
    printableLink: {
      type: String,
      required: true,
    },
    copy: {
      type: Boolean,
      required: true,
    },
    customerDeleted: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isSidebarCollapsed: false,
      isCopied: 0,
    };
  },
  created() {
    this.isCopied = this.copy;

    let isCollapsed = localStorage.getItem('user-collapsed-sidebar') === 'true';
    this.isSidebarCollapsed = isCollapsed;

    // 病院側サイドバーの拡大/縮小のタイミングで実行
    eventBus.$on(action.TOGGLE_COLLAPSED, () => {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    });
  },
  methods: {
    copyToClipboard(event) {
      event.preventDefault();

      var temp = document.createElement('textarea');
      temp.value = $('#clipboard').text();
      temp.selectionStart = 0;
      temp.selectionEnd = temp.value.length;
      var s = temp.style;
      s.position = 'fixed';
      s.left = '-100%';
      document.body.appendChild(temp);
      temp.focus();
      document.execCommand('copy');
      temp.blur();
      document.body.removeChild(temp);

      toastr.success('コピーしました');
    },
    toggleIsCopied(event) {
      event.preventDefault();
      $.ajax({
        url: this.action,
        type: 'POST',
        data: {
          utf8: '✓',
          _method: 'patch',
          authenticity_token: this.token,
          questionnaire: {
            copy: !this.isCopied,
          },
        },
      })
        .then(() => {
          this.isEditing = false;
          this.isCopied = !this.isCopied;
        })
        .catch(() => {
          this.$swal('コピーに失敗しました。');
        });
    },
  },
};
</script>

<style lang="sass" scoped>
textarea
  display: none

.footer
  position: fixed
  bottom: 0
  right: 0
  left: 220px
  z-index: 2

  .footer-navbar
    background-color: rgba(255,255,255,.9)
    padding: 15px 0
    border: none
    border-radius: 0
    margin-bottom: 40px
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1)

  &.active
    left: 60px

  .customer-deleted
    font-size: 14px
    position: absolute
    right: 240px
    margin: 0
</style>
